module.exports = __webpack_public_path__ + "static/img/sorina.f67d564.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sorina.jpg
// module id = VA9A
// module chunks = 1